import GroupSelect from './GroupSelect'

export default GroupSelect
